import MuiCard, { CardProps as MuiCardProps } from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';

import styled from 'styled-components';

import { styledSystem, StyledSystemProps } from '../styledSystem';

interface CardProps extends Omit<MuiCardProps, 'color'>, StyledSystemProps {
  selected?: boolean;
}

export const Card = styled(({ color, ...props }: CardProps) => (
  <MuiCard {...props} />
))`
  &&& {
    border-radius: 12px;
    cursor: pointer;
    box-shadow: ${({ selected, theme }) =>
      selected ? `0 0 8px ${theme.palette.primary.main}` : null};
    ${styledSystem}
  }
`;

export { CardActions, CardActionArea, CardContent, CardHeader, CardMedia };
